import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/lib/auth/AuthProvider';
import { queryClient } from '@/lib/query/client';
import React, { Suspense } from 'react';
import CoverPage from '@/pages/CoverPage';
import ReaderPage from '@/pages/ReaderPage';
import AuthPage from '@/pages/auth/AuthPage';
import AuthCallbackPage from '@/pages/auth/AuthCallbackPage';
import ClaimHandlePage from '@/pages/auth/ClaimHandlePage';
import ProfilePage from '@/pages/profile/ProfilePage';
import EditProfilePage from '@/pages/profile/EditProfilePage';
import PublicationsPage from '@/pages/publications/PublicationsPage';
import NewPublicationPage from '@/pages/publications/NewPublicationPage';
import EditPublicationPage from '@/pages/publications/EditPublicationPage';
import PublicationDetailPage from '@/pages/publications/PublicationDetailPage';
import DocumentPage from '@/pages/documents/DocumentPage';

const EditorPage = React.lazy(() => import('@/pages/documents/EditorPage'));
const WikiPage = React.lazy(() => import('@/pages/WikiPage'));

import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import './theme/variables.css';

setupIonicReact();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <IonApp>
          <IonReactRouter>
            <IonRouterOutlet>
              <Route exact path="/" component={CoverPage} />
              <Route exact path="/read" component={ReaderPage} />
              <Route exact path="/read/:id([0-9a-f-]{36})" component={ReaderPage} />
              <Route exact path="/auth" component={AuthPage} />
              <Route exact path="/auth/callback" component={AuthCallbackPage} />
              <Route exact path="/auth/claim-handle" component={ClaimHandlePage} />
              <Route exact path="/@:handle" component={ProfilePage} />
              <Route exact path="/settings/profile" component={EditProfilePage} />
              <Route exact path="/publications" component={PublicationsPage} />
              <Route exact path="/publications/new" component={NewPublicationPage} />
              <Route exact path="/publications/:id([0-9a-f-]{36})/edit" component={EditPublicationPage} />
              <Route exact path="/publications/:id([0-9a-f-]{36})" component={PublicationDetailPage} />
              <Route exact path="/documents/:id([0-9a-f-]{36})" component={DocumentPage} />
              <Route exact path="/edit/:id([0-9a-f-]{36})">
                <Suspense fallback={<div className="flex min-h-screen items-center justify-center"><div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-200 border-t-[#2f3e46]" /></div>}>
                  <EditorPage />
                </Suspense>
              </Route>
              <Route exact path="/wiki/:slug">
                <Suspense fallback={<div className="flex min-h-screen items-center justify-center"><div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-200 border-t-[#2f3e46]" /></div>}>
                  <WikiPage />
                </Suspense>
              </Route>
              <Route exact path="/wiki">
                <Suspense fallback={<div className="flex min-h-screen items-center justify-center"><div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-200 border-t-[#2f3e46]" /></div>}>
                  <WikiPage />
                </Suspense>
              </Route>
              <Route exact path="/home">
                <Redirect to="/" />
              </Route>
            </IonRouterOutlet>
          </IonReactRouter>
        </IonApp>
      </AuthProvider>
    </QueryClientProvider>
  );
}
